import React,{useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faStarOfLife } from '@fortawesome/free-solid-svg-icons';
const DevProfileData = (props) => {
    const {profileData} = props;

    // ---- define all state here ---- //
    const [showPassword, setShowPassword] = useState(false);
    const decodePassword = atob(profileData.password);

    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    <div className="row mb-7">
                        <label className="col-lg-4 fw-semibold text-muted">Full Name</label>
                        <div className="col-lg-8">
                            <span className="fw-bold fs-6 text-gray-800">
                                {profileData?.user_full_name}
                            </span>
                        </div>
                    </div>
                    <div className="row mb-7">
                        <label className="col-lg-4 fw-semibold text-muted">
                            System User Email
                        </label>
                        <div className="col-lg-8 fv-row">
                            <span className="fw-semibold text-gray-800 fs-6">
                                {profileData?.user_email}
                            </span>
                        </div>
                    </div>
                    <div className="row mb-7">
                        <label className="col-lg-4 fw-semibold text-muted">
                            Assign Agent
                        </label>
                        <div className="col-lg-8 align-items-center">
                            {profileData.agent_name.map((agentName, index) => (
                                <span className="badge badge-light-primary me-2 mb-1" key={index}>
                                    {agentName}
                                </span>
                            ))}
                        </div>
                    </div>
                    <div className="row mb-7">
                        <label className="col-lg-4 fw-semibold text-muted">
                            Manage Permission
                        </label>
                        <div className="col-lg-8 d-flex align-items-center">
                            {
                                profileData?.manage_permission?.allow_change_permission === 'Y' && (
                                    <span className="badge badge-light-dark me-2">
                                        Allow change permission
                                    </span>
                                )
                            }
                            {
                                profileData?.manage_permission?.allow_data_add === 'Y' && (
                                    <span className="badge badge-light-dark me-2">
                                        Allow data add
                                    </span>
                                )
                            }
                            {
                                profileData?.manage_permission?.allow_data_delete === 'Y' && (
                                    <span className="badge badge-light-dark me-2">
                                        Allow data delete
                                    </span>
                                )
                            }
                            {
                                profileData?.manage_permission?.allow_data_edit === 'Y' && (
                                    <span className="badge badge-light-dark me-2">
                                        Allow data edit
                                    </span>
                                )
                            }
                        </div>
                    </div>
                    <div className="row mb-7">
                        <label className="col-lg-4 fw-semibold text-muted">
                            Username
                        </label>
                        <div className="col-lg-8 d-flex align-items-center">
                            <span className="fw-bold fs-6 text-gray-800 me-2">
                                {profileData?.username}
                            </span>
                        </div>
                    </div>
                    <div className="row mb-7">
                        <label className="col-lg-4 fw-semibold text-muted">
                            Password
                        </label>
                        <div className="col-lg-8 d-flex align-items-center">
                            <span className="fw-bold fs-6 text-gray-800 me-2">
                                {showPassword ? decodePassword : '*'.repeat(decodePassword.length)}
                            </span>
                            <FontAwesomeIcon 
                                icon={showPassword ? faEyeSlash : faEye} 
                                className='fs-6 cursor-pointer text-gray-600'
                                onClick={()=> setShowPassword(!showPassword)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    )
}

export default DevProfileData